import {useFormContext, useWatch} from "react-hook-form";

export default function useConditionalField(conditionField, conditionFieldValues) {
    const {getValues} = useFormContext();

    const conditionFieldValue = useWatch({
        name: conditionField,
        disabled: !conditionField,
    }) ?? getValues(conditionField);

    if (!conditionField || conditionFieldValue === undefined) return false;

    const values = Array.isArray(conditionFieldValues) ? conditionFieldValues : [conditionFieldValues];

    const normalizedValues = (typeof conditionFieldValue === 'boolean')
        ? values.map(v => v === '1' ? true : v === '0' ? false : v)
        : values;

    if (Array.isArray(conditionFieldValue)) {
        return !conditionFieldValue.some(v => normalizedValues.includes(v));
    }

    return !normalizedValues.includes(conditionFieldValue);
}
